module.exports = __webpack_public_path__ + "img/mix-1.42a9e5a4.webp";